import React, { Component } from "react";
import { CartesianGrid, Legend, ResponsiveContainer, XAxis, YAxis, Tooltip, Bar, ComposedChart, Line } from "recharts";
import { Layout, Breadcrumb, Space, DatePicker, PageHeader, Select } from "antd";
import { RightOutlined } from "@ant-design/icons";

import { all as AllStats } from "../../api/Stats";
import { all as AllCareUnit } from "../../api/CareUnit.js";

import locale from 'antd/lib/locale/fr_FR';
import moment from "moment";

const { Content } = Layout;
const { RangePicker } = DatePicker;
const { Option } = Select;

const layoutSelect = {
  showSearch: true,
  allowClear: true,
  defaultActiveFirstOption: true,
  optionFilterProp: "children",
  style: {
    width: 400
  }
};

/**
 *
 */
class DailyInterventionChart extends Component {
  /**
   *
   * @param {*} props
   */
  constructor(props) {
    super(props);

    let now = moment();

    this.state = {
      startDate: now.clone().subtract(1, "weeks"),
      endDate: now.clone(),
      stats: [],
      careUnits: [],
      selectedCareUnitIds: []
    };

    this.defaultValue = [
      moment().subtract(1, "weeks"),
      moment()
    ];

    this.title = "Interventions journalières";
    this.onChangeDate = this.onChangeDate.bind(this);
    this.onChangeCareUnits = this.onChangeCareUnits.bind(this);

    this.timeOutFetchCareUnits = React.createRef();
  }

  async componentDidMount() {
    await this.fetchCareUnits('');
    let firstDay = moment().subtract(1, "weeks");
    let lastDay = moment();
    this.loadStats(firstDay, lastDay);
  }

  /**
   *
   * @param {*} startDate
   * @param {*} endDate
   */
  loadStats(startDate, endDate) {
    let selectedCareUnitIds = this.state.selectedCareUnitIds;
    let payload = {};
    if (selectedCareUnitIds.length) {
      payload['care_unit_ids'] = selectedCareUnitIds;
    }

    AllStats(startDate, endDate, payload).then((data) => {
      this.setState({ stats: data["stats"]["stats"] });
    });
  }

  /**
   *
   * @param {*} search
   */
  fetchCareUnits(search) {
    return AllCareUnit({
      current: 1,
      pageSize: 10,
      q: {
        search,
      },
    })
      .then((data) => {
        this.setState({ careUnits: data.results });
      });
  }

  /**
   *
   * @param {*} e
   */
  onChangeCareUnits(e) {
    this.setState({ selectedCareUnitIds: e }, () => {
      let { startDate, endDate } = this.state;
      this.loadStats(startDate, endDate);
    });
  }

  /**
   *
   * @param {*} date
   * @param {*} dateStrings
   */
  onChangeDate(dates, dateStrings) {
    this.setState({
      startDate: dates[0],
      endDate: dates[1]
    }, () => {
      let { startDate, endDate } = this.state;
      this.loadStats(startDate, endDate);
    });
  }
  render() {
    let { startDate, endDate, stats, careUnits } = this.state;
    let careUnitOptions = careUnits.map((option, index) => (
      <Option key={index} value={option.id}>{option.name}</Option>
    ));

    let data = stats.map((item) => {
      return {
        name: moment(item.date, 'YYYYMMDD').format('DD/MM/YYYY'),
        current_planned: item.current_planned,
        current_unplanned: item.current_unplanned,
        total_bed_capacity: item.total_bed_capacity,
      };
    });

    return (
      <Content
        style={{
          margin: "24px 16px",
          padding: 24,
          minHeight: 280,
        }}
      >
        <Breadcrumb
          style={{ padding: 24 }}
          separator={<RightOutlined style={{ fontSize: "75%" }} />}
        >
          <Breadcrumb.Item>
            <a href="/home">Accueil</a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Reporting</Breadcrumb.Item>
          <Breadcrumb.Item>{this.title}</Breadcrumb.Item>
        </Breadcrumb>
        <PageHeader ghost={false} title={this.title} />
        <div
          className="site-layout-background"
          style={{ padding: 24, minHeight: 360 }}
        >
          <Space
            direction="horizontal"
            size={12}
            className="mb-4"
            align="start"
          >
            <Space direction="vertical">
              <label>Dates :</label>
              <RangePicker
                locale={locale}
                format="DD/MM/YYYY"
                ranges={{
                  "Aujourd'hui": [moment(), moment()],
                  "Cette semaine": [
                    moment().startOf("week"),
                    moment().endOf("week"),
                  ],
                  "Ce mois": [
                    moment().startOf("month"),
                    moment().endOf("month"),
                  ],
                  "Les 7 derniers jours": [moment().subtract(7, 'days'), moment()],
                  "Les 7 prochains jours": [moment(), moment().add(7, 'days')],
                  "Les 30 derniers jours": [moment().subtract(30, 'days'), moment()]
                }}
                defaultValue={[startDate, endDate]}
                onChange={this.onChangeDate}
              />
            </Space>
            <Space direction="vertical">
              <label>Unité(s) de soin(s) :</label>
              <Select
                {...layoutSelect}
                mode="multiple"
                placeholder="Filtrer sur une/des unité(s) de soin"
                onChange={this.onChangeCareUnits}
                notFoundContent="Rechercher une unité de soin"
              >
                {careUnitOptions}
              </Select>
            </Space>
          </Space>
          <ResponsiveContainer width='100%' height={400} className="chart_container">
            <ComposedChart
              data={data}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name"/>
              <YAxis/>
              <Tooltip />
              <Legend />
              <Bar
                dataKey="current_unplanned"
                fill="#8884d8"
                stackId="a"
              />
              <Bar
                dataKey="current_planned"
                fill="#82ca9d"
                stackId="a"
              />
              <Line
                type="monotone"
                dataKey="total_bed_capacity"
                stroke="#8884d8"
                activeDot={{ r: 8 }}
              />
            </ComposedChart>
          </ResponsiveContainer>
        </div>
      </Content>
    );
  }
}

export default DailyInterventionChart;
